module.exports = "/images/arrow-down-green.svg?509e95f58c9561a9978c9e89eab3761d";